// extracted by mini-css-extract-plugin
export default {"container":"S2rLQ","item":"qzp96"};